import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';
import { Eyebrow } from '../primitives/shell.tsx';

/** `reserve` holds its height from the first paint, so nothing below moves when its lines land. */
export function Region({
  title,
  aside,
  reserve,
  tone,
  className,
  hold,
  children,
}: {
  title: string;
  aside?: ReactNode;
  reserve?: string;
  /** Something in it is money exposed. */
  tone?: 'warn' | undefined;
  className?: string;
  /** Handlers on the region itself, as Needs you uses to hold its order while it is read. */
  hold?: HTMLAttributes<HTMLElement>;
  children?: ReactNode;
}) {
  return (
    <section
      {...hold}
      className={clsx(
        'flex flex-col overflow-clip rounded-box border bg-surface',
        tone === 'warn' ? 'border-warn/40' : 'border-line',
        reserve,
        className,
      )}
    >
      <header className="py-panel flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 border-b border-line-soft px-gutter">
        <Eyebrow as="h2">{title}</Eyebrow>
        {aside}
      </header>
      <div className="p-card flex flex-1 flex-col gap-3">{children}</div>
    </section>
  );
}
